<template>
<div>
    <div class="text-center pt-5">
        <p class="text-center" block>Create your <b>MyPhoneShop</b> Account</p>
    </div>
    <v-container class="py-0 px-4">
        <!-- <v-alert class="my-2" :value="true" v-if="status" :type="status == 'success' ? 'success' : 'error'">{{ status == 'success' ? 'Registered Successfully' : status }}</v-alert> -->
        <v-form ref="form" v-model="valid"  @submit.prevent="submitRegistration">
            <v-text-field
                color="secondary"
                v-model="email"
                :rules="emailRules"
                label="Email Address"
                required>
            </v-text-field>
            <v-text-field
                    color="secondary"
                    v-model="username"
                    :rules="usernameRules"
                    label="Username"
                    required>
            </v-text-field>
            <v-text-field
                    color="secondary"
                    v-model="referralUsername"
                    label="Referral username (optional)"
                    required>
            </v-text-field>
            <!--<v-text-field-->
            <!--color="secondary"-->
            <!--v-model="fName"-->
            <!--:rules="firstNameRules"-->
            <!--label="First Name"-->
            <!--required>-->
            <!--</v-text-field>-->
            <!--<v-text-field-->
            <!--color="secondary"-->
            <!--v-model="lName"-->
            <!--:rules="lastNameRules"-->
            <!--label="Last Name"-->
            <!--required>-->
            <!--</v-text-field>-->
            <!--<v-menu-->
                <!--ref="menu1"-->
                <!--:close-on-content-click="false"-->
                <!--v-model="menu"-->
                <!--:nudge-right="40"-->
                <!--lazy-->
                <!--transition="scale-transition"-->
                <!--offset-y-->
                <!--full-width-->
                <!--max-width="290px"-->
                <!--min-width="290px">-->
                <!--<v-text-field-->
                    <!--color="secondary"-->
                    <!--slot="activator"-->
                    <!--v-model="dateFormatted"-->
                    <!--label="Birthday (mm/dd/yyyy)"-->
                    <!--persistent-hint-->
                    <!--append-icon="event"-->
                    <!--@blur="date = parseDate(dateFormatted)">-->
                <!--</v-text-field>-->
                <!--<v-date-picker color="secondary" v-model="date" no-title @input="menu = false"></v-date-picker>-->
            <!--</v-menu>-->
            <!--<v-layout row wrap align-end>-->
                <!--<v-flex xs3>-->
                    <!--<v-combobox-->
                        <!--color="secondary"-->
                        <!--v-model="country"-->
                        <!--:items="countries2"-->
                        <!--item-text="code_name"-->
                        <!--item-value="id"-->
                        <!--required>-->
                    <!--</v-combobox>-->
                <!--</v-flex>-->
                <!--<v-flex xs9>-->
                    <!--<v-text-field color="secondary" v-model="mobileNumber" :rules="mobileNumberRules" label="Mobile Number" required></v-text-field>-->
                <!--</v-flex>-->
            <!--</v-layout>-->
            <!--<v-textarea color="secondary" v-model="address" :rules="addressRules" label="Address" required></v-textarea>-->
            <!--<v-text-field-->
                <!--color="secondary"-->
                <!--v-model="password"-->
                <!--:append-icon="showPass ? 'visibility_off' : 'visibility'"-->
                <!--:rules="[passwordRules.required, passwordRules.min]"-->
                <!--:type="showPass ? 'text' : 'password'"-->
                <!--name="input-10-1"-->
                <!--label="Password"-->
                <!--hint="At least 8 characters"-->
                <!--@click:append="showPass = !showPass">-->
            <!--</v-text-field>-->
            <p class="text-center">
                <small>
                    <b>By signing up you agree that you have read and accepted the<br>
                        <a href="javascript:" class="text-dark">Terms and Conditions and Privacy Policy of MyPhoneShop.</a>
                    </b>
                </small>
            </p>
            <v-btn :disabled="loading" block depressed color="secondary" class="text-capitalize" type="submit">Create Account</v-btn>
            <div class="text-center">
                <v-btn flat class="text-capitalize text-decoration" block to="/login-manual" :ripple="false">Already have an Account? Sign In</v-btn>
            </div>
        </v-form>
    </v-container>
    <v-container class="px-4 pb-4">
        <div class="text-center pb-1">
            <p class=""><b>OR REGISTER WITH</b></p>
        </div>
        <div class="buttons">
            <v-flex>
                <v-btn :disabled="loading" @click="submitFacebookRegistration" color="#3B5998" dark depressed block class="text-capitalize">
                    <v-icon class="justify-start">mdi-facebook-box</v-icon>
                    <span>Facebook</span>
                </v-btn>
            </v-flex>
            <v-flex>
                <v-btn @click="googleLogin" :disabled="loading" color="#CC3333" dark depressed block class="text-capitalize">
                    <v-icon class="justify-start">mdi-google-plus-box</v-icon>
                    <span>Google</span>
                </v-btn>
            </v-flex>
            <v-flex>
                <v-btn @click="twitterLogin" :disabled="loading" color="#1DA1F3" dark depressed block class="text-capitalize">
                    <v-icon class="justify-start">mdi-twitter-box</v-icon>
                    <span>Twitter</span>
                </v-btn>
            </v-flex>
        </div>
    </v-container>
    <loader v-show="loading"></loader>
    <modal
            :dialog="dialogSuccessRegister"
            confirmMessage="Confirm"
            @actionConfirm="confirmRegisterDone"
            :width="700" >
            <div style="display: flex; align-items: center; flex-direction: column;">
                <img src="https://image.flaticon.com/icons/svg/291/291201.svg" style="width: 30%; height: 30%; padding: 16px 0;"/>
                <p style="font-weight: bold; font-size: 1.5rem;">Registration Completed</p>
                <p style="align-self: flex-start;">You have successfully registered to my|CrazySale. Please check your email for your temporary password.</p>
            </div>
    </modal>
</div>
</template>

<script>
import Modal from "./Modal";
export default {
    components: {Modal},
    data: vm => ({
        dialogSuccessRegister : false,
        date                : new Date().toISOString().substr(0, 10),
        dateFormatted       : vm.formatDate(new Date().toISOString().substr(0, 10)),
        menu                : false,
        showPass            : false,
        valid               : false,
        fName               : '',
        username            : '',
        referralUsername    : '',
        firstNameRules: [
            v => !!v || 'First Name is Required',
        ],
        lName: '',
        lastNameRules: [
            v => !!v || 'Last Name is Required',
        ],
        usernameRules: [
            v => !!v || 'Username is required',
            // v => /^[a-zA-Z0-9_]*$/.test(v) || "Special character not allowed",
            v => /^\S*$/.test(v) || "space is not allowed",
        ],
        mobileNumber: '',
        mobileNumberRules: [
            v => !!v || 'Mobile Number is Required',
        ],
        email: '',
        emailRules: [
            v => !!v || 'Email is Required',
            v => /^[^<>()[\]\\,;:\%#^\s@\"$&!@]+@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'please enter a valid email address.',
        ],
        password: '',
        passwordRules: {
            required: value => !!value || 'Required.',
            min: v => v.length >= 8 || 'Min 8 characters',
            emailMatch: () => ('The email and password you entered don\'t match')
        },
        address: '',
        addressRules: [
            v => !!v || 'Address is Required',
        ],
        country     : null,
        countries2  : [],
        status      : null,
        loading     : false,
    }),

    computed: {
        computedDateFormatted () {
            return this.formatDate(this.date)
        }
    },

    watch: {
        date (val)
        {
            this.dateFormatted = this.formatDate(this.date)
        }
    },

    methods: {
        triggerGoogle ()
        {
            document.getElementsByClassName("g-signin2").click()
        },
        formatDate (date)
        {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${year}-${month}-${day}`
        },
        parseDate (date)
        {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        getCountries2()
        {
            // axios.get('/api/g/country').then(res =>
            // {
                this.countries2[0] = [];
                this.countries2[0].code_name = "+63";
                this.countries2[0].code = "63";
                this.countries2[0].name = "Philippines";
                this.countries2.map((data,key)=> { this.countries2[key].code_name = "+" + data.code});
                this.country = this.countries2[0]
            // })
            // .catch(err =>
            // {

            // })
            // .finally(()=>{
            // });
        },
        submitFacebookRegistration()
        {
            this.loading = true;
            let a = this;

            FB.login(function(response)
            {
                if (response.status === 'connected')
                {
                    // Logged into your app and Facebook.
                    FB.api('/me', {
                        locale: 'en_US',
                        fields: 'id,email,first_name,middle_name,last_name,gender,locale,age_range,picture,address' },
                        function(info)
                        {
                            let req_data = {}

                            req_data.first_name         = info.first_name
                            req_data.last_name          = info.last_name
                            req_data.email              = info.email ? info.email : 'DEFAULT_EMAIL_ADDRESS@' + response.authResponse.userID + ".m1w"
                            req_data.address            = info.address ? info.address : 'DEFAULT_ADDRESS_ANDROID' + response.authResponse.userID
                            req_data.birthday           = info.birthday ? info.birthday : '1890-04-11'
                            req_data.country_name       = "Philippines"
                            req_data.mobile_number      = "DEFAULT_CONTACT_ANDROID" + response.authResponse.userID
                            req_data.password           = info.email ? info.email + response.authResponse.userID : 'DEFAULT_EMAIL_ADDRESS' + response.authResponse.userID
                            // req_data.facebook_key       = response.authResponse.userID
                            req_data.facebook_key       = info.id
                            req_data.brand_influencer   = localStorage.getItem('current_lead')

                            axios.post('/api/mystory/registration', req_data)
                            .then(response =>
                            {

                                a.status = response.data.status;

                                a.toaster(response.data.status, response.data.status == 'success' ? 200 : 201);


                                if (response.data.status === "success")
                                {
                                    a.loginAuthentication(req_data.facebook_key, req_data.password);
                                }
                                a.loading = false;

                            })
                            .catch(err =>
                            {
                                // a.toaster(err.data.status, 300);
                                a.status = "Some error occured. Please try again."
                                window.scrollTo(0,0)
                                a.loading = false
                            })
                        }
                    )
                }
                else
                {
                    a.status = "Some error occured. Please try again."
                    window.scrollTo(0,0);
                    a.loading = false
                }
            }, 
            {
                scope: 'email',
                return_scopes: true,
            });
        },
        submitRegistration()
        {
            if (!this.loading && this.$refs.form.validate())
            {
                this.loading = true;
                this.status = null;
                let req_data = {};

                req_data.email                  = this.email;
                req_data.username               = this.username;
                if (req_data.referral_username != '') {
                    req_data.referral_username      = this.referralUsername;
                }
                // req_data.brand_influencer        = localStorage.getItem('current_lead');
                // req_data.first_name              = this.fName;
                // req_data.last_name               = this.lName;
                // req_data.address                 = this.address;
                // req_data.birthday                = this.dateFormatted;
                // req_data.country_name            = "Philippines";
                // req_data.mobile_number           = "+63" + this.mobileNumber;
                // req_data.password                = this.password;

                axios.post('/api/mycrazysale/registration', req_data)
                .then((response) =>
                {
                    // this.status = response.data.status;
                    this.loginAuthentication(req_data.email, req_data.password);
                    this.loading = false;
                    this.dialogSuccessRegister = true;
                })
                .catch((err) =>
                {
                    this.loading = false;
                    this.toaster(err.response.data, 201);
                    window.scrollTo(0,0);
                });
            }
        },
        confirmRegisterDone(){
            this.dialogSuccessRegister = false;
            this.$router.push({path : '/login-manual'});
        },
        loginAuthentication(username, password)
        {
            let req_data = {};
            req_data.username       = username;
            req_data.password       = password;
            req_data.grant_type     = "password";
            req_data.client_id      = this.$store.state.client_id;
            req_data.client_secret  = this.$store.state.client_secret;
            req_data.scope          = "";

            this.loading            = true;

            axios.post('/oauth/token', req_data).then(res =>
            {
                this.$store.commit('login', res.data);
                this.loading        = false;
                localStorage.setItem('token_type', 'Bearer');
                localStorage.setItem('access_token', res.data.access_token);
                axios.defaults.headers.common['Authorization'] = "Bearer "+ res.data.access_token;

                this.storeUser();

                this.toaster('You have succesfully registered.', 200);
            })
            .catch(err =>
            {
                this.error_message  = err.response.data.message;
                this.loading        = false;
            })
            .finally(()=>
            {
                // if(!this.error_message)
                // {
                //     var redirect;
                //     redirect = localStorage.getItem('callback_page') ? localStorage.getItem('callback_page') : "";
                //     this.$router.go(-1);
                // }
            });
        },
        storeUser()
        {
            axios.get('/api/user/info')
            .then(res =>
            {
                this.$store.commit('store_user',res.data);
                
                if (this.$store.state.saved_product)
                {
                    this.addToCart();
                }
                else
                {
                    location.href="/";
                }

            })
            .catch(err =>
            {
                this.toaster('something went wrong.', 201);
            })
            .finally(()=>
            {

            })
        },
        addToCart()
        {
            let formData = {};
            formData.branch = this.$store.state.saved_product.branch;
            formData.branchVariation = this.$store.state.saved_product.branchVariation;
            formData.quantity = this.$store.state.saved_product.quantity;

            axios.post('/api/cart', formData)
            .then(res => 
            {
                if (this.$store.state.saved_product.action == 'buy now')
                {
                    this.$router.push('/cart?checkout=1');
                }
                else
                {
                    this.$router.push('/cart');
                }
            })
            .catch(error =>
            {

            })
            .finally(()=>
            {

            });
        },
        clear()
        {
            this.$refs.form.resetValidation();
            this.fName = null;
            this.email = null;
            this.lName = null;
            this.address = null;
            this.dateFormatted = null;
            this.country = this.countries2[0];
            this.mobileNumber = null;
            this.password = null;
        },
        googleInit()
        {
            (function() {
                var po = document.createElement('script'); po.type = 'text/javascript'; po.async = true;
                po.src = 'https://apis.google.com/js/client.js?onload=onLoadCallback';
                var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(po, s);
            })()
        },
        googleLogin()
        {
            this.loading = true;

            var myParams =
            {
                'clientid' : '536496751992-bi549k1kfu8kh9lb3pe9l868fsmv95pq.apps.googleusercontent.com', //You need to set client id
                'cookiepolicy' : 'single_host_origin',
                'callback' : this.googleLoginCallback, //callback function
                'approvalprompt':'force',
                'scope' : 'https://www.googleapis.com/auth/plus.login https://www.googleapis.com/auth/plus.profile.emails.read'
            }

            gapi.auth.signIn(myParams)
        },
        googleLoginCallback(googleUser)
        {
            if (googleUser.status.signed_in)
            {
                axios.get('https://www.googleapis.com/oauth2/v1/userinfo?alt=json&access_token=' + googleUser.access_token).then(res =>
                {
                    let req_data = {}

                    req_data.first_name         = res.data.given_name;
                    req_data.last_name          = res.data.family_name;
                    req_data.email              = res.data.email ? res.data.email : 'DEFAULT_EMAIL_ADDRESS' + res.data.id;
                    req_data.address            = res.data.address ? res.data.address : 'DEFAULT_ADDRESS_ANDROID' + res.data.id;
                    req_data.birthday           = res.data.birthday ? res.data.birthday : '1890-04-11';
                    req_data.country_name       = "Philippines";
                    req_data.mobile_number      = "DEFAULT_CONTACT_ANDROID" + res.data.id;
                    req_data.password           = res.data.email ? res.data.email + res.data.id : 'DEFAULT_EMAIL_ADDRESS' + res.data.id;
                    req_data.google_key         = res.data.id;
                    req_data.brand_influencer   = localStorage.getItem('current_lead')

                    axios.post('/api/mystory/registration', req_data)
                    .then(response =>
                    {
                        this.status = response.data.status

                        if (this.status == "success")
                        {
                            this.toaster(response.data.status, 200);
                            this.loginAuthentication(req_data.google_key, req_data.password)
                            return;
                        }
                        this.toaster(response.data.status, 201);
                        this.loading = false;

                    })
                    .catch(err =>
                    {
                        this.status = "Some error occured. Please try again."
                        // a.toaster(err.data.status, 300);
                        window.scrollTo(0,0)
                        this.loading = false
                    })
                })
                .catch(err =>
                {
                    this.status = "Some error occured. Please try again."
                    window.scrollTo(0,0)
                    this.loading = false
                })
                .finally(()=>{
                });
            }
            else
            {
                this.status = "Some error occured. Please try again."
                window.scrollTo(0,0)
                this.loading = false
            }
        },
        twitterLogin()
        {
            location.href=process.env.VUE_APP_URL + "twitter/register"
        },
        twitterCallBack()
        {
            if (this.$route.query.status != "success")
            {
                this.status = this.$route.query.status
            }
        }
    },

    mounted()
    {
        this.getCountries2()
        this.googleInit()
        this.twitterCallBack()
    }
}
</script>

<style lang="scss">
@import "../scss/app.scss";

</style>
